import { createStore, applyMiddleware } from "redux";
import { createLogger } from "redux-logger";
import { persistStore } from "redux-persist";
import { thunk } from "redux-thunk";
import { persistedReducer } from "./rootReducer";

const logger = createLogger({
  predicate: () => process.env.NODE_ENV !== "production",
});
const middlewares = [thunk, logger];

export const store = createStore(
  persistedReducer,
  applyMiddleware(...middlewares)
);

export const persistor = persistStore(store);
